import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import CodeContent from './CodeContent';
import { Divider } from '@mui/material';
import EndpointContent from './EndpointContent';
import TabLenguaje from './TabLenguaje';

const CDR = () => {
    const [t] = useTranslation('global');
    const code =
        `
        curl --location 'https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr?key=Z4Khpx...'
        --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3Lncz...'
        --header 'Content-Type: application/json'
        --data '{ ... }'
        `
        const cCurl =
        `  
            curl --location --request GET 'https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr?key=Z4Khpx...'
            --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9...
            --header 'Content-Type: application/json'
            --data '{ ... }'
            `;
        const csRS =
        `   
            var options = new RestClientOptions("")
            {
            MaxTimeout = -1,
            };
            var client = new RestClient(options);
            var request = new RestRequest("https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr?key=Z4Khpx...", Method.Get);
            request.AddHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htb...");
            request.AddHeader("Content-Type", "application/json");
            var body = @"{ ... }";
            request.AddStringBody(body, DataFormat.Json);
            RestResponse response = await client.ExecuteAsync(request);
            Console.WriteLine(response.Content);
                `;
        const javaOK =
        `        
            OkHttpClient client = new OkHttpClient().newBuilder()
            .build();
            MediaType mediaType = MediaType.parse("application/json");
            RequestBody body = RequestBody.create(mediaType, "{ ... }");
            Request request = new Request.Builder()
            .url("https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr?key=Z4Khpx...")
            .method("GET", body)
            .addHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9y...")
            .addHeader("Content-Type", "application/json")
            .build();
            Response response = client.newCall(request).execute();
                `
        ;
        const phpHC =
        `
            <?php
            require_once 'HTTP/Request2.php';
            $request = new HTTP_Request2();
            $request->setUrl('https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr?key=Z4Khpx...');
            $request->setMethod(HTTP_Request2::METHOD_GET);
            $request->setConfig(array(
            'follow_redirects' => TRUE
            ));
            $request->setHeader(array(
            'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNo...',
            'Content-Type' => 'application/json'
            ));
            $request->setBody('{ ... }');
            try {
            $response = $request->send();
            if ($response->getStatus() == 200) {
                echo $response->getBody();
            }
            else {
                echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
                $response->getReasonPhrase();
            }
            }
            catch(HTTP_Request2_Exception $e) {
            echo 'Error: ' . $e->getMessage();
            }
        `;
        const csHTC =
        `         
            var client = new HttpClient();
            var request = new HttpRequestMessage(HttpMethod.Get, "https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr?key=Z4Khpx...");
            request.Headers.Add("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNo...");
            var content = new StringContent("{ ... }", null, "application/json");
            request.Content = content;
            var response = await client.SendAsync(request);
            response.EnsureSuccessStatusCode();
            Console.WriteLine(await response.Content.ReadAsStringAsync());
            `;
        const javaUNI =
        `        
            Unirest.setTimeouts(0, 0);
            HttpResponse<String> response = Unirest.put("https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr?key=Z4Khpx...")
            .header("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI...")
            .header("Content-Type", "application/json")
            .body("{}")
            .asString();
        
                `;
        const phpGZ =
        `     
            <?php
            $client = new Client();
            $headers = [
            'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.',
            'Content-Type' => 'application/json'
            ];
            $body = '{}';
            $request = new Request('GET', 'https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr?key=Z4Khpx...', $headers, $body);
            $res = $client->sendAsync($request)->wait();
            echo $res->getBody();
            `;

    return (
        <div id='cdr'>
            <Divider sx={{height:'70px'}}/>
            <Typography variant="h3" gutterBottom>
                {t('content.cdr.titulo')}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {t('content.cdr.descripcion')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.cdr.descripcion2')}
            </Typography>
            <EndpointContent method='GET' path='https://wscomprobante-p1.rapifac.com/v0/comprobantes/cdr'/>
            {/*<CodeContent code={code} />*/}
            <TabLenguaje curl={cCurl} csRS={csRS} javaOK={javaOK} phpRQ={phpHC} csHC={csHTC} java2UN={javaUNI} php2GZ={phpGZ} />
            <Typography variant="body1" gutterBottom>
                {t('content.cdr.descripcion3')}
            </Typography>
        </div>
    );
}
export default CDR